import React, { useState, useRef } from "react";

const TestHardware = () => {
  const [videoOn, setVideoOn] = useState(false);
  const [audioOn, setAudioOn] = useState(false);

  const videoRef = useRef(null);
  const analyserCanvas = useRef(null);

  const audioTest = async () => {
    const options = {
      audio: true,
    };
    try {
      const stream = await navigator.mediaDevices.getUserMedia(options);
      window.localStream = stream;
      const audioCtx = new AudioContext();
      const analyser = audioCtx.createAnalyser();
      analyser.fftSize = 2 ** 8;
      const audioSrc = audioCtx.createMediaStreamSource(stream);
      audioSrc.connect(analyser);
      const data = new Uint8Array(analyser.frequencyBinCount);
      const ctx = analyserCanvas.current.getContext("2d");

      const draw = (dataParm) => {
        analyser.getByteTimeDomainData(dataParm);
        dataParm = [...dataParm];
        ctx.fillStyle = "white"; //white background
        ctx.lineWidth = 6; //width of candle/bar
        ctx.strokeStyle = "#1a1a1a"; //color of candle/bar
        ctx.beginPath();
        const space = analyserCanvas.current.width / dataParm.length;
        let x = 0;
        dataParm.forEach((value, i) => {
          const v = value / 128;
          const y = (v * analyserCanvas.current.height) / 2;
          if (i === 0) {
            ctx.moveTo(x, y);
          } else {
            ctx.lineTo(x, y);
          }
          x += space;
          ctx.clearRect(
            0,
            0,
            analyserCanvas.current.width,
            analyserCanvas.current.height
          );
          ctx.stroke();
        });
      };
      const loopingFunction = () => {
        requestAnimationFrame(loopingFunction);
        analyser.getByteFrequencyData(data);
        draw(data);
      };
      /* "requestAnimationFrame" requests the browser to execute the code during the next repaint cycle. This allows the system to optimize resources and frame-rate to reduce unnecessary reflow/repaint calls. */
      requestAnimationFrame(loopingFunction);
      setAudioOn(true);
    } catch (err) {
      console.log(err);
    }
  };

  const stopAudio = () => {
    const audioTrack = window.localStream.getAudioTracks();
    var activeTrack = audioTrack.filter((data) => data.kind === "audio");
    if(activeTrack){
      activeTrack[0].stop();
    }
    setAudioOn(false);
  };

  const stopVideo = () => {
    let video = videoRef.current;
    const videoTrack = window.localStream.getVideoTracks();
    var activeTrack = videoTrack.filter((data) => data.kind === "video");
    if(activeTrack){
      activeTrack[0].stop();
      video.src = "";
    }
    
    setVideoOn(false);
  };

  const captureVideo = () => {
    let video = videoRef.current;
    navigator.mediaDevices
      .getUserMedia({
        video: true,
      })
      .then((stream) => {
        window.localStream = stream;
        video.srcObject = stream;
        video.play();
        setVideoOn(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="container hardware-check">
      <div className="video-container mx-auto">
        <video className="videostream" ref={videoRef}></video>
      </div>

      <div className="d-flex justify-content-between btn-container mx-auto mt-2">
        <div className="audio-container mx-auto">
          <canvas ref={analyserCanvas} />
        </div>
        <div
          className="d-flex justify-content-between"
          style={{ width: "40%" }}
        >
          <button className="btn btn-success" onClick={captureVideo}>
            <i className="fas fa-video"></i>
          </button>
          <button className="btn btn-success" onClick={stopVideo}>
            <i className="fas fa-video-slash"></i>
          </button>
          <button className="btn btn-success" onClick={audioTest}>
            <i className="fas fa-microphone"></i>
          </button>
          <button className="btn btn-success" onClick={stopAudio}>
            <i className="fas fa-microphone-slash"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestHardware;
